import { CreditNoteVersionDto } from '@api';

export const CREDIT_NOTE_VERSIONS: CreditNoteVersionDto[] = [];
